import { classInstance } from '@/shared/helpers/helpers';
import { CodeForm } from '@/features/authorization/code-form/code-form';
import { FormMessage } from '@/shared/form/form-message/form-message';

interface Callbacks {
	onCodeSent?: () => Promise<object>;
}

export class AccountSendCode {
	private readonly element: HTMLElement;
	private button: HTMLButtonElement;
	private callbacks: Callbacks;
	private codeElement: HTMLFormElement | null;
	private code: CodeForm | null;
	private message: FormMessage;
	private messageElement: HTMLElement;
	private errorMessage: string = '';

	constructor(element: HTMLElement, callbacks?: Callbacks) {
		if (!element) return;
		this.element = element;
		this.callbacks = callbacks;
		this.init();
	}

	/**
	 * @desc Добавление коллбэков после создания модалки.
	 * @param {Callbacks} callbacks объект типа Callbacks.
	 * @example
	 * const accountSendCode = app.classInstance.get(document.querySelector('.js-account-send-code'));
	 * accountSendCode.accountSendCode.addCallbacks({ onSubmit });
	 */
	public addCallbacks = (callbacks: Callbacks): void => {
		this.callbacks = { ...this.callbacks, ...callbacks };
	};

	public setMessage = (message: string | null, type?: string | null): void => {
		this.errorMessage = message || this.errorMessage;
		this.message.set(this.errorMessage, type);
	};

	public removeMessage = (): void => this.message.disable();

	private handleButtonClick = () => {
		if (this.callbacks.onCodeSent) {
			this.callbacks.onCodeSent()
				.then(
					(result) => result.json ? result.json() : result,
					(error)  => error?.json ? error.json() : error,
				)
				.then((result) => {
					this.removeMessage();
					if (result.status === 'success') {
						window.app.modal.open('#account-code');
						this.code.setTimer();
						this.code.setNumber(result.data.tel);
						if (result.data?.message) this.setMessage(result.data.message, 'success');
					}
					else this.setMessage(result.errors.map((err) => err.message).join('<br>'), 'error');
				});
		}
	};

	public init = (): void => {
		classInstance.set(this.element, { accountSendCode: this });
		this.button = this.element.querySelector('.account-send-code__button');
		this.codeElement = document.querySelector('.account-code__form');
		this.code = classInstance.get(this.codeElement).codeForm;
		this.button.addEventListener('click', this.handleButtonClick);
		this.messageElement = this.element.querySelector('.form-message');
		this.message = new FormMessage(this.messageElement);
	};

	public destroy = (): void => {
		classInstance.del(this.element, 'accountSendCode');
		this.button.removeEventListener('click', this.handleButtonClick);
		this.button = null;
		this.codeElement = null;
		this.code = null;
	};
}
